import { OnboardingNodeType } from '../steps/types';
import { OnboardingSteps } from '../types';

const prevSubmittedStep = (
  currentStep: number,
  stepsSequence: OnboardingNodeType[],
  steps: OnboardingSteps
): number => {
  const stepsToCheck = stepsSequence.slice(0, currentStep - 1).reverse();
  for (const step of stepsToCheck) {
    const onboardingSteps = steps[step];
    if (!onboardingSteps) {
      // this is just for type safety and should not happen
      continue;
    }

    const submittedStep = onboardingSteps.find((step) => step.submitted);
    if (submittedStep) {
      if (submittedStep.skipped) {
        // if the step is submitted and is skipped, it means it was a redirect.
        // in this case we need to continue looking for the actual submitted step
        continue;
      }
    }
    // if we got here, it means that:
    // 1. we found a step that is submitted and not skipped
    // 2. we found a step that is not not submitted but is skipped
    // 3. we found a step that is not submitted and not skipped which is an error
    // and should be an impossible situation
    // in all those cases, we just return to that step
    return stepsSequence.indexOf(step) + 1;
  }
  return 1;
};

export default prevSubmittedStep;
